import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import User from 'entities/user/model';
import Organization from 'entities/organization/model';
import { Privileges } from 'utils/privileges';
import { Features } from 'utils/features';

export const hasCommunityOrTeamsAccess = (
  user?: User | null,
  organization?: Organization
): boolean | null => {
  if (!user || !organization) {
    return null;
  }

  return (
    (user.hasFeature(Features.COMMUNITIES) || user.hasFeature(Features.TEAMS)) &&
    user.hasPrivilege(Privileges.COMMUNITIES_EDIT) &&
    organization.isCompany()
  );
};

// Returns null while it's loading
export const useRedirectIfNoCommunityAccess = (
  user?: User | null,
  organization?: Organization
): boolean | null => {
  const history = useHistory();
  const hasAccess = hasCommunityOrTeamsAccess(user, organization);

  useEffect(() => {
    if (hasAccess === false) {
      history.replace('/');
    }
  }, [hasAccess, history]);

  return hasAccess;
};
